import { ISetDeviceType } from '../actions/deviceType';

export const deviceType = (state = '', action: ISetDeviceType) => {
    switch (action.type) {
        case 'SET_DEVICE_TYPE':
            return action.payload;
        default:
            return state;
    }
};
